import React from "react";
import axios from 'axios';
import swal from 'sweetalert';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";

import Select from 'react-select';
import biometry from "./biometry";
import { checkingDriverStatus, setAadhaar, setAepsAmount, setAepsCashWithDrwalReq, setAepsMobile, setAepsRequest, setAepsResponse, setAepsSection, setAmount3, setBiometricDta, setBiometricDtaCaptureStatus, setCaptureUrl, setCurrentTimeStamp, setDeviceInfoUrl, setFullName, setMobile, setMoneyTransferSurChargeAmount3, setMoneyTransferTotalAmount3, setOrderId3, setReadyDeviceName, showCreateOrderResponse3, storeAepsReqBeforeBalanceEnuiry } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import XMLParser from 'react-xml-parser';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
import Loading from "react-fullscreen-loading";
import * as Spinner from 'react-spinkit';
import FooterComponet from "../FooterComponent/FooterComponet";
import tokenErrorHandler from "../tokenErrorHandler";
import biometryPaySprint from "./biometry-paysprint2";

import * as CryptoJS from 'crypto-js';
import { setSelectedBankName } from "../../redux/misc-data/misc-data.action";
import { event } from "jquery";
const httpClient = axios.create();
class AEPSSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            amountErrrMsg: '',
            aePsActionType: '',
            aePsActionErrMsg: '',
            orderServiceErrMsg: '',
            deviceConnectStatus: '',
            mobile: '',
            mobileErrorMsg: '',
            aadhaar: '',
            adhaarErrMsg: '',
            searchableBankList: [],
            selectedBankName: '',
            selectedBankId: '',
            bankDetails: [],
            ifscCode: '',
            bankErrMsg: '',
            IIN: 607152,
            //merchant code for paysprint is acquireId
            // acquireId:1,-for yes bank

            acquireId: '',
            iinErr: '',
            progress: '',
            name: '',
            nameErr: '',
            emptyList: [],

            cashWithdrawlPricingValue: '',
            cashWithdrawlPricingErr: ''
        }
    }



    componentDidMount() {



        // var transaction = {
        //     mobile: this.state.mobile,
        //     customerId: this.state.aadhaar,
        //     amount: this.state.aePsActionType == 'cashWithDrawl' ? this.state.amount : 0,
        //     operator: this.state.bankIIN,
        //     category: this.state.aePsActionType == 'ministatement' ? 'AEPS_MINI_STATEMENT' :
        //         this.state.aePsActionType == 'cashWithDrawl' ? 'AEPS_CASHOUT' :
        //             this.state.aePsActionType == 'balanceEnquiry' && 'AEPS_BALANCE_ENQUIRY'
        // }

        // alert(JSON.stringify(this.props.aepsReqBeforeBalanceEnuiry));
        // if (this.props.aepsReqBeforeBalanceEnuiry != undefined &&
        //     this.props.aepsReqBeforeBalanceEnuir != null &&
        //     this.props.aepsReqBeforeBalanceEnuir != '') {

        // }

        store.dispatch(setAepsCashWithDrwalReq(''));
        store.dispatch(setCaptureUrl(''));
        store.dispatch(setDeviceInfoUrl(''));
        store.dispatch(setReadyDeviceName(''));
        store.dispatch(checkingDriverStatus(''));
        store.dispatch(setBiometricDta(''));

        store.dispatch(setAepsResponse(''))
        store.dispatch(setAepsRequest(''))
        store.dispatch(setSelectedBankName(''))
        store.dispatch(setFullName(''))
        store.dispatch(setAadhaar(''))
        store.dispatch(setMobile(''))
        store.dispatch(setCurrentTimeStamp(''))
        store.dispatch(setBiometricDtaCaptureStatus(''));

        this.loadBankList();

        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: '',
            aadhaar: '',
        })

    }
    componentWillUnmount() {
    }



    loadBankList() {

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        var searchableBankList = [];
        var bankDetailsUrl = '/api/v1/paysprint/aeps/connector/bankList';
        httpClient.get(bankDetailsUrl,
            { headers }
        ).then((response) => {
            console.log('bank list' + JSON.stringify(response.data.data));
            if (response.data.data.length > 0) {
                if (response.data.data != null
                    && response.data.data != undefined
                    && response.data.data != '') {
                    this.setState({
                        bankDetails: response.data
                    })
                    if (response.data.data.length > 0) {
                        response.data.data.map(bank => {
                            var stateVal = {
                                value: '',
                                label: ''
                            }
                            stateVal.value = bank.iinno;
                            stateVal.label = bank.bankName;

                            searchableBankList.push(stateVal);
                        })
                    }
                }
                this.setState({
                    searchableBankList: searchableBankList
                })
            }
        }
        ).catch(error => {

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }

        });
    }



    bankChange = (selected) => {

        this.setState({
            bankErrMsg: '',
            selectedBankName: selected.label,
            bankIIN: selected.value
        })
    }
    enterMobile = (e) => {
        e.preventDefault();
        this.setState({
            mobileErrorMsg: '',
            mobile: e.target.value
        })
    }
    enterFullName = (e) => {
        e.preventDefault();
        this.setState({
            nameErr: '',
            name: e.target.value
        })
    }
    enterAadhaar = (e) => {
        e.preventDefault();
        this.setState({
            adhaarErrMsg: '',
            aadhaar: e.target.value
        })
    }

    enterIIN = (e) => {
        e.preventDefault();
        this.setState({
            IIN: e.target.value
        })
    }

    enterAcquireUd = (e) => {
        e.preventDefault();
        this.setState({
            acquireId: e.target.value
        })
    }

    selectAmount = (e, amount) => {
        e.preventDefault();
        this.setState({
            amountErrrMsg: '',
            amount: amount
        })

    }
    enterAmount = (e) => {
        e.preventDefault();
        this.setState({
            amountErrrMsg: '',
            amount: e.target.value
        })
    }

    captureFingerPrint = () => {
        this.setState({
            orderServiceErrMsg: ''
        })
        var validateAepsValue = this.validateBeforeAeps();
        if (validateAepsValue == true) {
            store.dispatch(setCaptureUrl(''))
            store.dispatch(setDeviceInfoUrl(''))
            store.dispatch(setReadyDeviceName(''))
            store.dispatch(checkingDriverStatus(''))

            store.dispatch(setBiometricDta(''));
            store.dispatch(setAepsResponse(''))
            store.dispatch(setAepsRequest(''))
            store.dispatch(setSelectedBankName(''))
            store.dispatch(setFullName(''))
            store.dispatch(setAadhaar(''))
            store.dispatch(setMobile(''))
            store.dispatch(setCurrentTimeStamp(''))
            store.dispatch(setBiometricDtaCaptureStatus(''));

            console.log('calling capturefingerprint');

            biometryPaySprint.captureFingerPrint(this.props.captureUrl, this.props.deviceInfoUrl);
        }



    }

    proceedToAeps = (event) => {
        event.preventDefault();
        this.validateBeforeAeps();
    }



    validateBeforeAeps = () => {
        this.setState({
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            aePsActionErrMsg: '',
            bankErrMsg: '',
            iinErr: '',
            nameErr: '',
            orderServiceErrMsg: ''
        })
        var nameValidation = false;
        var mobileValidation = false;
        var amountValidation = false;
        var adhaarValidation = false;
        var actionTypeValidation = false;
        var bankValidation = false;

        if (this.state.mobile == '' || this.state.mobile.length != 10) {
            this.setState({
                mobileErrorMsg: 'Please enter valid mobile No'
            })
        } else {
            mobileValidation = true;
        }
        if (this.state.aePsActionType == 'cashWithDrawl' && this.state.amount == '') {
            amountValidation = false;
            this.setState({
                amountErrrMsg: 'Please enter valid amount'

            })
        } else {
            amountValidation = true;
        }


        if (this.state.aadhaar == '' ||
            (this.state.aadhaar.length != 12)) {
            this.setState({
                adhaarErrMsg: 'Please enter valid adhaarNo'
            })
        } else {
            adhaarValidation = true;
        }
        if (this.state.name == '') {
            this.setState({
                nameErr: 'Please enter name'
            })
        } else {
            nameValidation = true;
        }


        if (this.state.aePsActionType == '') {
            this.setState({
                aePsActionErrMsg: 'Please select an aeps Action'
            })
        } else {
            actionTypeValidation = true;
        }
        if (this.state.selectedBankName == '' || this.state.selectedBankName == 'Select Bank') {
            this.setState({
                bankErrMsg: 'Please select a bank'
            })
        } else {
            bankValidation = true;
        }


        //etc

        if (mobileValidation == true && amountValidation == true && adhaarValidation == true
            && actionTypeValidation == true
            && nameValidation == true && bankValidation == true
            //  && bankValidation == true
        ) {
            return true
        } else {
            return false
        }
    }

    showAepsTxnHistory = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('txnHistory'));
    }

    selectAction(event) {
        store.dispatch(checkingDriverStatus(''));
        store.dispatch(setBiometricDtaCaptureStatus(''));
        store.dispatch(setBiometricDta(''));
        this.setState({
            aePsActionErrMsg: '',
            aePsActionType: event.target.value,
            mobileErrorMsg: '',
            amountErrrMsg: '',
            adhaarErrMsg: '',
            bankErrMsg: '',
            iinErr: '',
            nameErr: '',
            orderServiceErrMsg: ''


            // selectedBankName:'',
        })
        if (event.target.value == 'cashWithDrawl') {
            this.setState({
                amount: '',
                cashWithdrawlPricingValue: ''

            })
        }
    }


    calculatePricing() {

        this.setState({
            displayErrorMsg: '',
            cashWithdrawlPricingErr: ''
        })
        store.dispatch(setMoneyTransferTotalAmount3(''));
        store.dispatch(setMoneyTransferSurChargeAmount3(''));
        store.dispatch(showCreateOrderResponse3(''));
        store.dispatch(setOrderId3(''));
        store.dispatch(setAmount3(''));

        const header = {
            msgType: "CALCULATE_PRICING",
            service: "PRICING",
            // dstService:"CUSTOM_SERVICE",
            channel: "ADMIN",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var pricingUrl = '/api/v1/pricing/calculate';



        const pricingReq = {
            header: header,
            entityId: this.props.agentInfo.id,
            entityType: "RETAILER",
            productTree:
            {
                serviceCode: "BANKING",
                categoryCode: 'AEPS',
                productCode: 'CASHOUT',
                // "categoryCode": "PAYOUT",
                // "productCode": "PAYSPRINT"
            },
            txnAmount: parseFloat(this.state.amount).toFixed(2)

        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('pricing req:' + JSON.stringify(pricingReq));

        httpClient.post(pricingUrl, pricingReq, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            this.setState({
                progressStatus: false,
                calculatePricingFiledLock: true
            })

            console.log('pricing response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                console.log('pricing service response:' + JSON.stringify(response.data));
                store.dispatch(setMoneyTransferTotalAmount3(this.state.amount));
                store.dispatch(setMoneyTransferSurChargeAmount3(response.data.pricingAmount));
                store.dispatch(showCreateOrderResponse3(''));
                store.dispatch(setOrderId3(''));
                store.dispatch(setAmount3(''));
                this.setState({
                    cashWithdrawlPricingValue: response.data.pricingAmount
                })

            } else {
                this.setState({
                    cashWithdrawlPricingErr: response.data.response.displayMsg
                })

            }
        }).catch(error => {

            this.setState({
                progressStatus: false,
                orderServiceErrMsg: error.message
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }
        })
    }

    calculatePricingForCashWithdrawl = (event) => {
        event.preventDefault();
        var isPricingOk = this.validateBeforeCashWithdrawlPricing();
        if (isPricingOk) {

            //pricing call
            this.calculatePricing();
        }

    }

    validateBeforeCashWithdrawlPricing() {
        if (this.state.amount == '') {
            this.setState({
                amountErrrMsg: 'Please enter valid amount'
            })
            return false;
        } else {
            return true;
        }
    }

    unlockAmountEdit = (event) => {
        event.preventDefault();
        this.setState({
            cashWithdrawlPricingValue: ''
        })
    }

    aepsAction = (event) => {
        event.preventDefault();

        if (this.state.aePsActionType != 'cashWithDrawl') {

            store.dispatch(setAepsResponse(''))
            store.dispatch(setAepsRequest(''))
            store.dispatch(setSelectedBankName(''))
            store.dispatch(setFullName(''))
            store.dispatch(setAadhaar(''))
            store.dispatch(setMobile(''))
            store.dispatch(setCurrentTimeStamp(''))


            if (this.validateBeforeAeps() == true) {
                this.setState({
                    progress: 'loading',
                    orderServiceErrMsg: ''
                })
                var url = '';

                if (this.state.aePsActionType == 'ministatement') {
                    // url = '/api/v1/paysprint/aeps/connector/statement';
                    url = '/api/v1/aeps/order/create';
                }

                if (this.state.aePsActionType == 'balanceEnquiry') {
                    // url = '/api/v1/paysprint/aeps/connector/balance';
                    url = '/api/v1/aeps/order/create';
                }

                var header = {
                    msgType: "CREATE_ORDER",
                    service: "AEPS",
                    src: 'aeps',
                    dst: 'aeps',
                    channel: "WHITELABEL",
                    requesterId: this.props.clientRequesterId,
                    requestId: uuidv4(),
                    time: moment().utc(),
                }

                if (this.state.aePsActionType == 'balanceEnquiry') {
                    store.dispatch(storeAepsReqBeforeBalanceEnuiry(''));
                }

                var transaction = {
                    mobile: this.state.mobile,
                    customerId: this.state.aadhaar,
                    amount: this.state.aePsActionType == 'cashWithDrawl' ? this.state.amount : 0,
                    operator: this.state.bankIIN,
                    category: this.state.aePsActionType == 'ministatement' ? 'AEPS_MINI_STATEMENT' :
                        this.state.aePsActionType == 'cashWithDrawl' ? 'AEPS_CASHOUT' :
                            this.state.aePsActionType == 'balanceEnquiry' && 'AEPS_BALANCE_ENQUIRY'
                }

                var optional = new Map();
                var newstr = '';

                var btoaxmlDta = atob(this.props.aepsBiometricDta);

                var serialNum = '';
                var sessionKey = '';
                var hmacXml = '';
                var dataXml = '';
                var type = '';
                var certExp = '';
                var version = '';
                var timestamp = '';


                optional.set('BIOMETRIC',
                    btoaxmlDta
                );

                var agentId = '';

                if (process.env.REACT_APP_ENV == 'UAT') {
                    agentId = this.props.agentInfo.id
                }
                if (process.env.REACT_APP_ENV == 'PROD') {
                    agentId = this.props.agentInfo.id
                }

                var request = {
                    header: header,
                    device: this.props.deviceInfo,
                    agentId: agentId,
                    validated: true,
                    transaction: transaction,
                    optional: Object.fromEntries(optional),
                }

                const headers = {
                    'Authorization': 'Bearer ' + this.props.token,
                    'client-id': this.props.agentInfo.id,
                    'role': this.props.clientRole
                }

                store.dispatch(setAepsResponse(''))
                store.dispatch(setAepsRequest(''))
                store.dispatch(setSelectedBankName(''))
                store.dispatch(setFullName(''))
                store.dispatch(setAadhaar(''))
                store.dispatch(setMobile(''))
                store.dispatch(setCurrentTimeStamp(''))



                httpClient.post(url, request, {
                    timeout: 180 * 1000,
                    timeoutErrorMessage: 'timeout',
                    headers
                }).then((response) => {
                    console.log('aeps action response' + JSON.stringify(response.data));

                    // response.data = { "header": { "msgType": "AEPS_BALANCE_ENQUIRY", "service": "AEPS", "src": "aeps", "dst": "aeps", "channel": "WHITELABEL", "requesterId": "W767285296CMS", "requestId": "64069b9b-d222-41d9-bd7b-4987b896c2d2", "time": "2022-11-25T06:46:15.418", "traceId": "245e1dbf-3a8b-4523-a3a4-397150e512b4", "hops": null }, "response": { "traceId": "245e1dbf-3a8b-4523-a3a4-397150e512b4", "success": true, "code": null, "msg": "SUCCESS", "displayMsg": "balance enquiry successful", "tpsRspMsg": "AEPS Balance Enquiry Success", "time": "2022-11-25T12:16:20.985971524", "exception": null }, "orderId": "e2ca9e3e-045f-42fe-a5a4-48bfbe955493", "operatorId": "11775747", "bankId": "232912050864", "balance": "512.0", "statement": null, "optional": null }

                    if (response.data.response.success == true &&
                        response.data.response.msg == 'SUCCESS') {
                        this.setState({
                            progress: 'completed'
                        })


                        store.dispatch(setBiometricDtaCaptureStatus(''));

                        if (request.transaction.category == 'AEPS_MINI_STATEMENT') {
                            store.dispatch(setAepsResponse(response.data))
                            store.dispatch(setAepsRequest(request))
                            store.dispatch(setSelectedBankName(this.state.selectedBankName))
                            store.dispatch(setFullName(this.state.name))
                            store.dispatch(setAadhaar(this.state.aadhaar))
                            store.dispatch(setMobile(this.state.mobile))
                            store.dispatch(setCurrentTimeStamp(moment().format('DD-MM-YYYY HH:mm:ss')))

                            store.dispatch(setAepsSection('ministatement'))
                        }

                        if (request.transaction.category == 'AEPS_BALANCE_ENQUIRY') {
                            store.dispatch(storeAepsReqBeforeBalanceEnuiry(request));

                            store.dispatch(setAepsResponse(response.data))
                            store.dispatch(setAepsRequest(request))
                            store.dispatch(setSelectedBankName(this.state.selectedBankName))
                            store.dispatch(setFullName(this.state.name))
                            store.dispatch(setAadhaar(this.state.aadhaar))
                            store.dispatch(setMobile(this.state.mobile))
                            store.dispatch(setCurrentTimeStamp(moment().format('DD-MM-YYYY HH:mm:ss')))
                            store.dispatch(checkingDriverStatus(''));

                            store.dispatch(setAepsSection('balanceEnquiry'))
                        }
                    } else {
                        var msg = '';
                        if (response.data.response.tpsRspMsg != null &&
                            response.data.response.tpsRspMsg != undefined &&
                            response.data.response.tpsRspMsg != '' &&
                            response.data.response.tpsRspMsg.trim().includes("response_code")) {

                            var arrayV = response.data.response.tpsRspMsg.trim().split(":");
                            msg = (arrayV[arrayV.length - 1]);
                            
                            msg = msg.substring(1, msg.length - 4);

                            // msg = response.data.response.tpsRspMsg.substring(response.data.response.tpsRspMsg.indexOf("message:"),
                            //     response.data.response.tpsRspMsg.length);
                        } else {
                            msg = response.data.response.tpsRspMsg;
                        }
                        this.setState({
                            progress: 'completed',
                            orderServiceErrMsg: (msg == '') ? response.data.response.displayMsg :
                                msg
                        })
                        store.dispatch(setBiometricDtaCaptureStatus(''));

                    }
                }).catch(error => {
                    this.setState({
                        progress: 'completed',
                        orderServiceErrMsg: error.message
                    })
                    store.dispatch(setBiometricDtaCaptureStatus(''));

                    console.log(error.message);

                    if (error.message.includes("401")) {
                        tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                    }
                });
            }
        } else {
            store.dispatch(setAepsResponse(''))
            store.dispatch(setAepsRequest(''))
            store.dispatch(setSelectedBankName(''))
            store.dispatch(setFullName(''))
            store.dispatch(setAadhaar(''))
            store.dispatch(setMobile(''))
            store.dispatch(setCurrentTimeStamp(''))


            if (this.validateBeforeAeps() == true) {
                this.setState({
                    progress: 'loading',
                    orderServiceErrMsg: ''
                })
                var url = '';


                if (this.state.aePsActionType == 'cashWithDrawl') {
                    // url = '/api/v1/paysprint/aeps/connector/withdrawal';
                    url = '/api/v1/aeps/order/create';
                }


                var header = {
                    msgType: "CREATE_ORDER",
                    service: "AEPS",
                    src: 'aeps',
                    dst: 'aeps',
                    channel: "WHITELABEL",
                    requesterId: this.props.clientRequesterId,
                    requestId: uuidv4(),
                    time: moment().utc(),
                }

                var transaction = {
                    mobile: this.state.mobile,
                    customerId: this.state.aadhaar,
                    amount: this.state.aePsActionType == 'cashWithDrawl' ? this.state.amount : 0,
                    operator: this.state.bankIIN,
                    category: this.state.aePsActionType == 'ministatement' ? 'AEPS_MINI_STATEMENT' :
                        this.state.aePsActionType == 'cashWithDrawl' ? 'AEPS_CASHOUT' :
                            this.state.aePsActionType == 'balanceEnquiry' && 'AEPS_BALANCE_ENQUIRY'
                }

                var optional = new Map();
                var newstr = '';

                var btoaxmlDta = atob(this.props.aepsBiometricDta);
                // alert('btoaxmlDta:'+btoaxmlDta);
                // for (var i = 0; i < btoaxmlDta.length; i++) {
                //     if (!(btoaxmlDta[i] == '\n' || btoaxmlDta[i] == '\r' || btoaxmlDta[i] == '\\'))
                //         newstr += btoaxmlDta[i];
                // }
                // alert(newstr.trim())
                // console.log(JSON.stringify(biometricDataToJson));

                var serialNum = '';
                var sessionKey = '';
                var hmacXml = '';
                var dataXml = '';
                var type = '';
                var certExp = '';
                var version = '';
                var timestamp = '';

                // var biometricDataToJson = new XMLParser().parseFromString(btoaxmlDta);

                // biometricDataToJson.children.map(child => {
                //     if (child.name == 'DeviceInfo') {

                //         var chMap = child.children;
                //         var dataMap = [];

                //         chMap.map(data => {
                //             if (data.name == 'additional_info') {
                //                 dataMap = data.children;
                //             }
                //         })
                //         dataMap.map(data => {

                //             if (data.attributes.name == 'srno') {
                //                 serialNum = data.attributes.value;
                //             }
                //             if (data.attributes.name == 'ts') {
                //                 timestamp = data.attributes.value;
                //             }
                //         })

                //     }

                //     if (child.name == 'Skey') {
                //         sessionKey = child.value;
                //     }
                //     if (child.name == 'Hmac') {
                //         hmacXml = child.value
                //     }
                //     if (child.name == 'Data') {
                //         dataXml = child.value;
                //         type = child.attributes.type;
                //     }
                // })

                optional.set('BIOMETRIC',
                    btoaxmlDta
                );

                var agentId = '';

                if (process.env.REACT_APP_ENV == 'UAT') {
                    agentId = this.props.agentInfo.id
                }
                if (process.env.REACT_APP_ENV == 'PROD') {
                    agentId = this.props.agentInfo.id
                }

                var request = {
                    header: header,
                    device: this.props.deviceInfo,
                    agentId: agentId,
                    validated: true,
                    transaction: transaction,
                    optional: Object.fromEntries(optional),
                }

                const headers = {
                    'Authorization': 'Bearer ' + this.props.token,
                    'client-id': this.props.agentInfo.id,
                    'role': this.props.clientRole
                }

                store.dispatch(setAepsCashWithDrwalReq(request));

                store.dispatch(setAepsResponse(''))
                store.dispatch(setAepsRequest(''))
                store.dispatch(setSelectedBankName(this.state.selectedBankName))
                store.dispatch(setFullName(this.state.name))
                store.dispatch(setAadhaar(this.state.aadhaar))
                store.dispatch(setMobile(this.state.mobile))
                store.dispatch(setCurrentTimeStamp(moment().format('DD-MM-YYYY HH:mm:ss')))

                var goToAepsCashWithdrawllDetails = document.getElementById('goToAepsCashWithdrawllDetails');
                goToAepsCashWithdrawllDetails.click();
            }
        }


    }

    render() {

        return (
            <div class="col-12 col-lg-7 col-xl-8">
                <div class="card-b" id="rightdiv">
                    <div id="aepservices">
                        <div class="head">
                            <div class="hright">
                                <button class="close btn" data-toggle="tooltip" title="Close"
                                    onClick={this.showAepsTxnHistory}></button>
                            </div>
                            <Link to='/aeps-transfer'>
                                <button id='aepsTransfer' hidden={true}></button>
                            </Link>
                            <Link to='/aeps-cashwithdrawl'>
                                <button id='goToAepsCashWithdrawllDetails' hidden={true}></button>
                            </Link>

                            <h3>AePS Services</h3>
                        </div>
                        <div class="reviewbox">
                            <form onSubmit={this.proceedToAeps}>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-floating mb-3 mt-3">

                                            <div onChange={this.selectAction.bind(this)}>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" id="aeps1" name="aeps"
                                                        value='cashWithDrawl'
                                                    // disabled={this.props.checkingDriverStatus != 'READY' && true} 
                                                    /><label class="custom-control-label" for="aeps1">Cash Withdrawal</label>
                                                </div>

                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" id="aeps3" name="aeps"
                                                        value='ministatement'
                                                    // disabled={this.props.checkingDriverStatus != 'READY' && true} 
                                                    /><label class="custom-control-label" for="aeps3">Mini Statement</label>
                                                </div>
                                                <div class="custom-control custom-radio custom-control-inline">
                                                    <input type="radio" class="custom-control-input" id="aeps4" name="aeps"
                                                        value='balanceEnquiry'
                                                    // disabled={this.props.checkingDriverStatus != 'READY' && true} 
                                                    /><label class="custom-control-label" for="aeps4">Balance Enquiry</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.aePsActionErrMsg != '' &&
                                        <div class='valid-error'>
                                            {this.state.aePsActionErrMsg}
                                        </div>
                                    }

                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="text" id="name" class="form-control"
                                                placeholder="Enter Name" name="name"
                                                onChange={this.enterFullName}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required
                                            />
                                            <label for="name">Full Name</label>
                                        </div>
                                        {this.state.nameErr != '' &&
                                            <div class='valid-error'>
                                                {this.state.nameErr}
                                            </div>
                                        }
                                    </div>


                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="number" id="mdn" class="form-control"
                                                placeholder="Enter mobile" name="mobile"
                                                value={this.state.mobile}
                                                onChange={this.enterMobile}
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required />
                                            <label for="mdn">Mobile Number</label>
                                        </div>
                                        {this.state.mobileErrorMsg != '' &&
                                            <div class='valid-error'>
                                                {this.state.mobileErrorMsg}
                                            </div>
                                        }

                                    </div>

                                    <div class="col-12 col-sm-6">
                                        <div class="form-floating mb-3 mt-3">
                                            <input type="number" id="adhar" class="form-control"
                                                placeholder="Enter Aadhaar" name="Aadhaar"
                                                value={this.state.aadhaar}
                                                onChange={this.enterAadhaar}
                                                onInput={(e) => e.target.value = e.target.value.slice(0, 12)}
                                                readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}
                                                required />
                                            <label for="adhar">Aadhaar Number</label>
                                        </div>
                                        {this.state.adhaarErrMsg != '' &&
                                            <div class='valid-error'>
                                                {this.state.adhaarErrMsg}
                                            </div>
                                        }
                                    </div>

                                    <div class="col-12 col-sm-6">

                                        {this.props.aepsBiometricDtaCaptureStatus != 'success' ?
                                            <div class="form-floating mb-3 mt-3">
                                                <Select class="mdb-select"
                                                    //  options={this.state.emptyList}
                                                    options={this.state.searchableBankList}
                                                    SelectContainer={true}
                                                    defaultValue={{
                                                        label: this.state.selectedBankName == '' ? 'Select Bank' : this.state.selectedBankName,
                                                        value: this.state.selectedBankName == '' ? 'Select Bank' : this.state.selectedBankName
                                                    }}
                                                    onChange={this.bankChange}
                                                    placeholder={this.state.selectedBankName}
                                                    readOnly={this.props.aepsBiometricDtaCaptureStatus == 'success' && true}

                                                />
                                            </div> :
                                            <div class="form-floating mb-3 mt-3">
                                                <input type="text" id="bank-choose" class="form-control"
                                                    name="bank-choose"
                                                    value={this.state.selectedBankName}

                                                    readOnly
                                                />
                                                <label for="adhar">Bank</label>
                                            </div>

                                        }

                                        {this.state.bankErrMsg != '' &&
                                            <div class='valid-error'>
                                                {this.state.bankErrMsg}
                                            </div>
                                        }
                                    </div>

                                    <div class="col-12 col-sm-6">
                                        {this.state.aePsActionType == 'cashWithDrawl' &&
                                            <div class="form-floating mb-3 mt-3 input-group amtmrgn">
                                                <input type="number" id="amt" class="form-control"
                                                    placeholder="Enter Amount" name="amount"
                                                    value={this.state.amount}
                                                    onChange={this.enterAmount}
                                                    readOnly={this.state.cashWithdrawlPricingValue != ''
                                                        && true}
                                                    required
                                                />
                                                <label for="amt">Amount</label>
                                                {this.state.cashWithdrawlPricingValue != '' &&
                                                    <button class="edtamt1" type="button" onClick={this.unlockAmountEdit}
                                                        data-bs-toggle="tooltip" title="Edit amount"></button>
                                                }
                                            </div>
                                        }





                                        {this.state.aePsActionType == 'cashWithDrawl' &&
                                            <div class="amtbtn">
                                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 100)}
                                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                                >₹100</button>
                                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 500)}
                                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                                >₹500</button>
                                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 1000)}
                                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                                >₹1000</button>
                                                <button type="button" class="lbbtn1" onClick={e => this.selectAmount(e, 5000)}
                                                    disabled={this.state.cashWithdrawlPricingValue != '' && true}
                                                >₹5000</button>
                                                {this.state.amountErrrMsg != '' &&
                                                    this.state.aePsActionType == 'cashWithDrawl' &&
                                                    <div class='valid-error'>
                                                        {this.state.amountErrrMsg}
                                                    </div>
                                                }
                                            </div>


                                        }


                                    </div>
                                    <div class="col-12 col-sm-6">

                                        <br />
                                        {this.state.aePsActionType == 'cashWithDrawl' &&
                                            this.state.cashWithdrawlPricingValue != '' &&
                                            <div class="amtshow"
                                            >
                                                <h6>Commission: ₹{parseFloat(this.state.cashWithdrawlPricingValue).toFixed(2)}</h6>
                                            </div>
                                        }
                                        {this.state.cashWithdrawlPricingErr != '' &&
                                            <div class='valid-error'>
                                                Pricing:
                                                {" " + this.state.cashWithdrawlPricingErr}
                                            </div>}
                                    </div>


                                    <div class="w-100"></div>
                                    {this.state.aePsActionType == 'cashWithDrawl' ?
                                        this.state.cashWithdrawlPricingValue == '' ?
                                            <div class="col-12 col-sm-6">
                                                <button type="button" class="btn btn-primary" id="capturenow"
                                                    onClick={this.calculatePricingForCashWithdrawl}>Calculate Pricing</button>
                                                {this.state.orderServiceErrMsg != ''
                                                    &&
                                                    <div class='valid-error'>
                                                        {
                                                            this.state.orderServiceErrMsg
                                                        }</div>}

                                            </div> :
                                            // this.props.checkingDriverStatus == 'READY' ?
                                            (this.props.aepsBiometricDtaCaptureStatus != 'success' ?
                                                <div class="col-12 col-sm-6">
                                                    <button type="button" class="btn btn-primary" id="capturenow"
                                                        onClick={this.captureFingerPrint}>Capture Fingerprint</button>
                                                    {this.state.orderServiceErrMsg != ''
                                                        &&
                                                        <div class='valid-error'>
                                                            {
                                                                this.state.orderServiceErrMsg
                                                            }</div>}
                                                    {this.props.aepsBiometricDtaCaptureStatus == 'success' &&
                                                        <div class='valid-success'>
                                                            Fingerprint captured successfully
                                                        </div>}
                                                </div> :
                                                <div class="col-12 col-sm-6">
                                                    <button type="submit" class="btn btn-primary" id="proceedAeps"
                                                        onClick={this.aepsAction}
                                                        disabled={this.state.progress == 'loading' && true}
                                                    >Proceed</button>
                                                    {this.state.orderServiceErrMsg != ''
                                                        &&
                                                        <div class='valid-error'>
                                                            {
                                                                this.state.orderServiceErrMsg
                                                            }</div>}
                                                    {this.state.progress == 'loading' &&
                                                        <div class='valid-success'>
                                                            Please wait...</div>}
                                                </div>)
                                        :
                                        this.state.aePsActionType != '' ?
                                            (this.props.aepsBiometricDtaCaptureStatus != 'success' ?
                                                <div class="col-12 col-sm-6">
                                                    <button type="button" class="btn btn-primary" id="capturenow"
                                                        onClick={this.captureFingerPrint}>Capture Fingerprint</button>
                                                    {this.state.orderServiceErrMsg != ''
                                                        &&
                                                        <div class='valid-error'>
                                                            {
                                                                this.state.orderServiceErrMsg
                                                            }</div>}
                                                    {this.props.aepsBiometricDtaCaptureStatus == 'success' &&
                                                        <div class='valid-success'>
                                                            Fingerprint captured successfully
                                                        </div>}
                                                </div> :
                                                <div class="col-12 col-sm-6">

                                                    <button type="submit" class="btn btn-primary" id="proceedAeps"
                                                        onClick={this.aepsAction}
                                                        disabled={this.state.progress == 'loading' && true}
                                                    >Proceed</button>
                                                    {this.state.orderServiceErrMsg != ''
                                                        &&
                                                        <div class='valid-error'>
                                                            {
                                                                this.state.orderServiceErrMsg
                                                            }</div>}
                                                    {this.state.progress == 'loading' &&
                                                        <div class='valid-success'>
                                                            Please wait...</div>}
                                                </div>
                                            ) :
                                            <div class="col-12 col-sm-6">
                                                <div class='valid-success'>
                                                    *Please select an aeps Action to proceed
                                                    <button type="button" class="btn btn-primary" id="capturenow"
                                                        disabled>Capture Fingerprint</button>
                                                </div>

                                            </div>
                                    }

                                    {/* {(this.props.aepsBiometricDta != '' &&
                                        this.props.aepsBiometricDta != 'error') ?
                                        <div class="col-12 col-sm-6">
                                            <div class="device"><i class="connect"></i> Biometric device connected and fingerprint scanned for Aadhaar authentication</div>
                                        </div> :
                                        this.props.aepsBiometricDta == 'error' &&
                                        <div class="col-12 col-sm-6">
                                            <div class="device"><i class="disconnect"></i> Biometric device not connected or Driver not installed!
                                                Please make sure to connect device before go to AePS page</div>
                                        </div>
                                    } */}


                                    {
                                        (this.props.checkingDriverStatus == 'READY' &&
                                        this.props.aepsBiometricDta != '' &&
                                        this.props.aepsBiometricDta != 'error') ?
                                            <div class="col-12 col-sm-6">
                                                <div class="device"><i class="connect"></i> Biometric device connected and fingerprint scanned for Aadhaar authentication</div>
                                            </div>
                                            :
                                            this.props.checkingDriverStatus == 'LOADING' ?
                                                <div class="col-12 col-sm-6">
                                                    <div class="device"><i class="connect"></i> Detecting Biometric Driver status..Please wait</div>
                                                </div>
                                                :
                                                this.props.checkingDriverStatus == 'ERROR' &&
                                                <div class="col-12 col-sm-6">
                                                    <div class="device"><i class="disconnect"></i> Biometric device not connected or Driver not installed!
                                                        Please make sure to connect device before go to AePS page</div>
                                                </div>
                                     
                                    }

                                </div>
                            </form>
                        </div>
                    </div>


                </div>


                {this.props.checkingDriverStatus == 'LOADING' &&
                    <div className="loader">
                        <div className="loader-content">
                            <Spinner name="ball-spin-fade-loader" />
                            <div className="loader-message"> Detecting Driver status..Please wait </div>
                        </div>
                    </div>
                }
            </div>

        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    aepsReduce: { aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus, deviceInfoUrl, captureUrl,
        aepsReqBeforeBalanceEnuiry },
    miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, deviceInfo, callBackUrl }
}
) => ({
    errorMessage, loginErrorMessage, aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus,
    deviceInfoUrl, captureUrl,
    aepsReqBeforeBalanceEnuiry,
    phone, agentInfo,
    token, clientRole, clientRequesterId, deviceInfo, callBackUrl
});




export default connect(mapStateToProps, null)(AEPSSearch);
